import BaseContentDetailsPageNavView from "scripts/views/baseContentDetailsPageNavView";
import templateContentDetailsChapterPageNav from "templates/contentDetailsChapterPageNav.hbs";
import L from "lodash/fp";

class ContentDetailsChapterPageNavView extends BaseContentDetailsPageNavView {
  constructor(options) {
    super(options);
    this.organizationProperties = options.organizationProperties;
  }

  get template() {
    return templateContentDetailsChapterPageNav;
  }

  render() {
    const modelProps = this.model.toJSON();

    this.$el.html(
        this.template(
            L.merge(
                {
                  showComments: !this.organizationProperties.hideCommentsTab
                },
                modelProps,
            ),
        ),
    );

    this.updateLinkState();
    this.updatePosition();

    return this;
  }
}

export default ContentDetailsChapterPageNavView;
